import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getNotificationSettings, type NotificationSettings, saveNotificationSettings } from '../../../api/safetyRounds';

const KEY = ['safety-rounds', 'notification-settings'] as const;

export const useNotificationSettingsQuery = () => useQuery({ queryKey: KEY, queryFn: getNotificationSettings });

/** Each choice is saved as it changes, and the answer is what the server keeps */
export const useSaveNotificationSettingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (choices: NotificationSettings['events']) => saveNotificationSettings(choices),
    onSuccess: (settings) => queryClient.setQueryData(KEY, settings),
  });
};
